import { ChangeDetectorRef, Component, ElementRef, Injector, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { LoaderService } from '../../services/loader.service';
import { AlertsService } from '../../services/alerts.service';
declare var jQuery: any;

@Component({
    selector: 'app-diagnostic-ris-reports',
    templateUrl: './diagnostic-ris-reports.component.html',
    styleUrls: ['./diagnostic-ris-reports.component.scss'],
    standalone: false
})
export class DiagnosticRisReportsComponent extends UiEngineComponent implements OnInit {
  currentData: any = {};
  @Input() data: any;
  @Input() input: any;
  @ViewChild('kxFilter') kxFilter: ElementRef;
  searchConfig: any = {};
  formBlock: any = false;
  @Input() filterFieldGroup: any;
  @Input() config: any;
  apiData: any;
  searchColumns: any = "";
  search: any;
  result: any;
  resourceDef: any;
  filterFields: any = {};
  @Input() fields: Array<any>;
  filter = '';

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public alert: AlertsService
  ) {
    super(injector, router, route, modal);
  }

  ngOnInit(): void {
    console.log("Inside ngOnInit");
    this.fields = [];
    this.config = {};
    this.filterFields = undefined;
    this._currentData['gridData'] = {};
    this._currentData['resourceDef'] = {};
    this.config.archiveConfig = {};
    this.config.archiveConfig.selected = {};
    this.config.archiveConfig.selected.download_only = true;
    this.config.archiveMessage = "Report is ready to download.";
    this.checkResourceDef();
  }
  
  checkResourceDef(){
    this.baseService.getResourceDef(this.input, (data: any) => {
      if (data) {
        this.resourceDef = data;
        this.filterFields = {};
        this.resourceDef.heading_title = this.resourceDef.page_name.list;
        this.filterFields['blocks'] = this.resourceDef;
        this.fields = this.resourceDef.list.fields;
        this.config = this.resourceDef.config;
        this.config.downloadOnly = true;
        this.config.archiveConfig.selected = {};
        this.config.archiveConfig.selected.download_only = true;
        this._currentData['resouceDef'] = this.resourceDef;
        this._currentData['APIresource'] = this.resourceDef.list.APIresource;
        this._currentData['dataGridConfig'] = {};
        this._currentData['dataList'] = {};
        this.baseService.setTitle(this.resourceDef.heading_title);
        this.getData();
      }
    })
  }

  onFilter(event: any) {
    this.searchColumns = event.key;
    this.search = event.value;
    this.getData();
  }

  getData() {
    let datasource = this.resourceDef.list.APIresource;
    datasource['args'] = datasource.args ? this.baseService.buildDyanamicStr(datasource.args, {}) : '';
    datasource['filter'] = datasource.filter ? this.baseService.buildDyanamicStr(datasource.filter, {}) : '';
    datasource['resource'] = datasource.resource ? datasource.resource : '';
    datasource['application'] = datasource.application ? datasource.application : this.appService.getApplication();
    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application, datasource.filter).subscribe((res: any) => {
      if (res) {
        this.loader.hideSpinner();
        this.apiData = res;
        this.result = [];
      }else{
        this.result =[];
        this.alert.error(res.message);
      }
    })
  }

  getConfigValues(event){
    if (event && event.changePage != undefined){
      event.changePage = undefined;
    }
    super.getConfigValues(event);
  }

  // onBulkActionClicked(e){
  //   e
  // }

  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));
    if (this._currentData.APIresource && this._currentData.APIresource.args) {
      gridData['args'] = this._currentData.APIresource.args;
    }
    if (gridData && gridData.filter && this._currentData.gridData && this._currentData.APIresource && this._currentData.APIresource.filter) {
      this._currentData.gridData['filter'] = gridData.filter;
      this._currentData.APIresource.filter = gridData.filter;
    }
    this._currentData.gridData['args'] = gridData.args;
    super.bindGrid(resource, application, type, queryId, printInfo, callback);
  }
   
  ngAfterViewInit(){
    if (this.config && this.config.archiveConfig){
      jQuery('.btn-with-icon-label').hide();
    }

  }
}
